var _rect, _path, _g, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 186,
    viewBox: "0 0 221 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 75.0178,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_1508_31073)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 44.3227C105.039 42.8193 110.247 42.7821 115.14 44.2157L201.676 69.5645C207.399 71.241 207.437 79.3351 201.729 81.0647L115.378 107.232C110.337 108.759 104.95 108.72 99.9323 107.118L18.214 81.0381C12.618 79.2521 12.6564 71.3204 18.2695 69.5888L100.166 44.3227Z",
    fill: "#3D3D3D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1508_31073)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.5,
    cy: 73.0178,
    rx: 26.5,
    ry: 2,
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.51 35C142.51 54.33 126.84 70 107.51 70C88.1798 70 72.5098 54.33 72.5098 35C72.5098 15.67 88.1798 0 107.51 0C126.84 0 142.51 15.67 142.51 35Z",
    fill: "#4671F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.003 35C123.003 43.2843 116.288 50 108.003 50C99.7191 50 93.0034 43.2843 93.0034 35C93.0034 26.7157 99.7191 20 108.003 20C116.288 20 123.003 26.7157 123.003 35Z",
    fill: "url(#paint1_linear_1508_31073)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.003 35C114.003 38.3137 111.317 41 108.003 41C104.69 41 102.003 38.3137 102.003 35C102.003 31.6863 104.69 29 108.003 29C111.317 29 114.003 31.6863 114.003 35Z",
    fill: "#F3F1F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1508_31073",
    x: 69,
    y: 57.0178,
    width: 81,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1508_31073"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1508_31073",
    x1: 206,
    y1: 130.018,
    x2: 14,
    y2: 130.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1508_31073",
    x1: 93.3738,
    y1: 50,
    x2: 123.374,
    y2: 21.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDark);
export default __webpack_public_path__ + "static/media/illustration-dark.5d168ccb0bcd586b403e3c293bae1354.svg";
export { ForwardRef as ReactComponent };